module.exports = __webpack_public_path__ + "img/rulesCloud2.678fa3d5.png";